import { ISignInApiSdkConfig, SignInApiSdk } from '../api/SignInApiSdk';
import { SignInRepository } from '~repositories/SignInRepository';
import { ConfigStore } from './ConfigStore';
import { Container } from 'hypo-container';
import { ServiceBusController } from './ServiceBusController';
import serviceNames, { SessionManagementService } from './SessionManagementService';
import { ServiceManager } from '@estee/elc-service';
import { root, ServiceInitializer, IAppConfig } from '@estee/elc-universal-utils';
import { AuthSession } from '~domain/entities/AuthSession';
import { AuthSessionRepository } from '~repositories/AuthSessionRepository';
import { GuestRepository } from '~repositories/GuestRepository';
import { GuestUser } from '~domain/entities/GuestUser';
import { SignUpFormStore } from '~stores/SignUpFormStore';
import { FormValidator } from '@estee/elc-form';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

export const serviceInitializer: ServiceInitializer = async (config: IAppConfig) => {
    setConfig(config);

    const authRepo = diContainer.get(serviceNames.authSessionRepository);

    await authRepo.ensureRequestTransformer();
};

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.formValidator, (c) => new FormValidator())
    .register(serviceNames.httpTransport, (c) => root.HttpTransport)
    .register(serviceNames.signInApiSdk, (c) => {
        const configStore: ConfigStore = c.get(serviceNames.configStore);
        const config: ISignInApiSdkConfig = {
            businessUnitId: configStore.config.businessUnitId,
            httpTransport: c.get(serviceNames.httpTransport),
            baseUrl: configStore.config.baseUrl,
            configStore
        };

        return new SignInApiSdk(config);
    })
    .register(
        serviceNames.signUpFormStore,
        (c) =>
            new SignUpFormStore({
                configStore: c.get(serviceNames.configStore),
                formValidator: c.get(serviceNames.formValidator)
            })
    )
    .register(
        serviceNames.serviceBusController,
        (c) =>
            new ServiceBusController(
                c.get(serviceNames.authSession),
                c.get(serviceNames.careAuthSession),
                c.get(serviceNames.authSessionRepository),
                c.get(serviceNames.guestRepository)
            )
    )
    .register(
        serviceNames.sessionManagementService,
        (c) => new SessionManagementService(serviceInitializer)
    )
    .register(serviceNames.guestRepository, (c) => new GuestRepository())
    .register(serviceNames.guestUser, (c) => new GuestUser(''))
    .register(serviceNames.signInRepository, (c) => new SignInRepository())
    .register(
        serviceNames.authSessionRepository,
        (c) =>
            new AuthSessionRepository({
                signInApiSdk: c.get(serviceNames.signInApiSdk),
                authSession: c.get(serviceNames.authSession),
                careAuthSession: c.get(serviceNames.careAuthSession),
                httpTransport: c.get(serviceNames.httpTransport),
                configStore: c.get(serviceNames.configStore)
            })
    )
    .register(serviceNames.authSession, (c) => new AuthSession(null, null, null, null))
    .register(serviceNames.careAuthSession, () => new AuthSession(null, null, null, null));

export const serviceStarter = ServiceManager.startService;
